import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { ApiPropertiesFactory } from '@shared/factories/api-properties/api-properties.factory';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordGuard  {
  constructor(private apiService: ApiServiceService,
    private apiProperties: ApiPropertiesFactory,
    private context: ContextFactory,
    private router: Router){}
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.getProperties(route);
  }

  getProperties(route: ActivatedRouteSnapshot){
    return this.apiService.getConfig().then((data)=>{
      this.apiProperties.setApiProperties(data);
      return this.getLogin(route);
    },(errorData:any)=>{
      window.open(window.location.origin, '_self');
      return false;
    })
  }

  getLogin(route: ActivatedRouteSnapshot){
    let access = route.queryParams['access'];
    let objectLogin = { login: 'anonymous', password: access };
    return this.apiService.login(objectLogin, 'public')
    .then((data:any)=>{
      this.context.setLogin(data);
      return true;
    }, (errorData:any)=>{
      errorData.status === 410? this.router.navigateByUrl('change-password-error') : window.open('login', '_self');
      return false;
    })
  }
}
